// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zRij","rootMobile":"styles_rootMobile__j3olZ"};